import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import { OpalApiResponseDocument, OpalApiRequestParams } from '../../schema'

type RequestParams = OpalApiRequestParams<'ReadInMarketBFFV1'>
type ReadInMarketBFFResponse = OpalApiResponseDocument<'ReadInMarketBFFV1', 200>

export const readInMarketContent = ({ params }: { params: RequestParams }) => {
  const url = new URL(
    `/asgard-bff/${params.path.workspace_id}/in_market/calendar`,
    window.location.origin
  )

  url.search = queryString(params.query)

  return HttpClient()
    .get<ReadInMarketBFFResponse>(url.toString())
    .then((res) => res.data)
}
